module.exports = __webpack_public_path__ + "static/media/prova.719c5ccc.mp3";